<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" nz-input placeholder="Search Records" [(ngModel)]="searchText" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button nzType="primary" (click)="getAllAttachments()" nzSearch><i nz-icon
                            nzType="search"></i></button>
                </ng-template>
            </nz-form-item>

            <nz-form-item>
                <button nz-button nzType="primary" (click)="add()"><i nz-icon nzType="plus"></i>New Attachment</button>
            </nz-form-item>
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="attachmentData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)">

            <thead>
                <tr>
                    <th style="text-align: center;">Edit</th>
                    <th *ngFor="let column of columns" nzColumnKey="{{column[0]}}" [nzSortFn]="true">{{column[1]}}</th>
                    <th style="text-align: center;" nzColumnKey="IS_ACTIVE" [nzSortFn]="true">Active</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data">
                    <td style="text-align: center;"><a (click)="edit(data)"><i nz-icon nzType="edit"
                                nzTheme="outline"></i></a></td>
                    <td *ngFor="let column of columns">{{data[column[0]]}}</td>
                    <td style="text-align: center;">
                        <i nz-icon *ngIf="data.IS_ACTIVE" [nzType]="'check-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#52c41a'"></i>
                        <i nz-icon *ngIf="!data.IS_ACTIVE" [nzType]="'close-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#f50'"></i>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>
<div *ngIf="drawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="400" [nzVisible]="drawerVisible"
        [nzTitle]="drawerTitle" (nzOnClose)="drawerClose()" (nzKeyboard)="true">
        <app-attachment-drawer [drawerClose]="callBackDrawerClose" [data]="attachmentDrawerData"
            [typeData]="typeForAttachmentDrawer" [typeIDData]="typeIDForAttachmentDrawer"></app-attachment-drawer>
    </nz-drawer>
</div>